module.exports = __webpack_public_path__ + "img/group2_04_1.62e2c680.png";